import { Component, viewChild, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { RequestBuilderService } from '../../../../shared/services/request-builder.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-send-notification-to-all',
  standalone: true,
  imports: [FormsModule, ButtonComponent, TextareaModule, InputTextModule],
  templateUrl: './send-notification-to-all.component.html',
  styleUrl: './send-notification-to-all.component.scss',
})
export class SendNotificationToAllComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly requestBuilder = inject(RequestBuilderService);

  readonly notificationForm = viewChild.required<NgForm>('notificationForm');
  loading = false;

  confirmAction() {
    const notificationForm = this.notificationForm();
    if (notificationForm.invalid) return;

    this.loading = true;

    const body = {
      Title: notificationForm.value.title,
      Body: notificationForm.value.description,
    };
    this.requestBuilder.post(`notifications/send-all-partners-notification`, body).subscribe({
      next: () => {
        this.loading = false;
        this.ref.close({ confirmed: true });
      },
      error: error => {
        this.loading = false;
      },
    });
  }
}
